/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// TODO: Fix accessibility
// TODO: Fix interface with empty object

import { PlayCircleFill } from 'react-bootstrap-icons';
import Moment from 'react-moment';
import { useNavigate } from 'react-router-dom';
import { IMAGES_REPO } from '../../../static-resources';
import { VideoDataProps } from '../../../static-resources/static-misc';
import { DEFAULT_MONTH_DATE_FORMAT } from '../../../utils/formatting/date-formatter.helper';
import { HomeSlideCardComponentProps } from '../../home/components/home-slide-card.component';
import './viewallcard.component.scss';

export interface ViewAllCardComponentProps
  extends HomeSlideCardComponentProps {}
const ViewAllCardComponent = ({
  title,
  description,
  linkSrc,
  src,
  date,
  group,
}: VideoDataProps) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/video/${title}`, {
      state: { video: { title, description, linkSrc, src } },
    });
  };

  return (
    <div className="col-lg-4 viewAllCard">
      <div className="card bg-none">
        <div className="card-body">
          <div className="card-image pb-2" onClick={handleCardClick}>
            <span className="HeaderCardTitle">{title}</span>
            <img
              src={IMAGES_REPO.BackgroundCardsImage}
              alt="card-background-image"
            />
            <PlayCircleFill className="playButtonIcon" />
          </div>
          <div className="card-content-section">
            <div className="card-date">
              <Moment format={DEFAULT_MONTH_DATE_FORMAT}>{date}</Moment>
            </div>
            <div className="d-flex titlewithicon">
              <div className="card-title titlewithicon d-flex justify-content-between align-items-center">
                <h3 className="heading-link">{title}</h3>
                <img
                  src={IMAGES_REPO.RightArrowupIcon}
                  onClick={handleCardClick}
                  alt="arrow-up"
                />
              </div>
            </div>
            <div className="card-description">
              <p>{description}</p>
            </div>
            <div className="card-chips">
              <p className="chip-1">{group}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewAllCardComponent;
